import { Heading, Stack } from "@chakra-ui/react";
import type { ReactNode } from "react";
import type { FooterLinksCategoryType } from "../../types";

export const FooterLinksCategory = ({
  footerLinksCategoryDirection: linksAlignment,
  footerLinksCategoryName,
  children,
}: Pick<FooterLinksCategoryType, "footerLinksCategoryDirection" | "footerLinksCategoryName"> & {
  children: ReactNode;
}) => (
  <>
    {footerLinksCategoryName && (
      <Heading
        as="h4"
        textTransform="uppercase"
        fontWeight="medium"
        fontSize="sm"
        mb={4}
        letterSpacing="0.25px"
        data-testid="footer-category"
      >
        {footerLinksCategoryName}
      </Heading>
    )}
    <Stack direction={linksAlignment} spacing={6}>
      {children}
    </Stack>
  </>
);
